/**
 * Created by mac on 11.05.2026
 */

class Effects {
    constructor() {
        this.bundles = [];
        this.maps = {};
    }

    addBundle(bundleName) {
        this.bundles.push(bundleName);
    }

    removeBundle(bundleName) {
        const index = this.bundles.indexOf(bundleName);
        if (index !== -1) {
            this.bundles.splice(index, 1);
        }

        delete this.maps[bundleName];
    }

    getMap(bundleName) {
        if (this.maps[bundleName]) {
            return this.maps[bundleName];
        }

        const bundle = bundles[bundleName];
        if (!bundle || !bundle.isLoaded()) {
            return undefined;
        }

        const map = bundle.jsons.effectsmap_json && bundle.jsons.effectsmap_json.getJson();
        if (map) {
            this.maps[bundleName] = map;
        }

        return map || undefined;
    }

    findInBundles(event) {
        for (let i = this.bundles.length - 1; i >= 0; i--) {
            const map = this.getMap(this.bundles[i]);
            if (map && map[event] !== undefined) {
                return cleverapps.toArray(map[event]);
            }
        }
    }

    fire(events, node) {
        if (this.isLogEnabled()) {
            console.log("effects fired", events);
        }

        const { event, effects } = this.findEffects(events, node) || {};
        if (!event || !effects) {
            return;
        }

        const composite = {
            effect: event,
            handles: []
        };

        for (let i = 0; i < effects.length; i++) {
            const effect = effects[i];
            if (!effect || effect.silent) {
                continue;
            }

            let handler = null;
            if (effect.sound) {
                handler = this.applySound(effect);
            } else if (effect.music) {
                handler = this.applyMusic(effect);
            } else if (effect.haptic !== undefined) {
                handler = this.applyHaptic(effect);
            }

            if (handler) {
                composite.handles.push(handler);
            }
        }

        return composite;
    }

    fireAction(event, node) {
        return new cc.CallFunc(() => this.fire(event, node));
    }

    preload(events, node) {
        const { event, effects } = this.findEffects(events, node) || {};
        if (!event || !effects) {
            return;
        }

        for (let j = 0; j < effects.length; j++) {
            const effect = effects[j];
            if (!effect || effect.silent) {
                continue;
            }
            const sound = effect.sound || effect.music;
            const url = sound && bundles[effect.bundle] && bundles[effect.bundle].urls[sound];
            if (url && url.resolve()) {
                cleverapps.bundleLoader.ensureSoundsLoaded(url);
            }
        }
    }

    findEffects(events, node) {
        events = cleverapps.toArray(events) || [];
        node = node || cleverapps.Scenes.GetRunningScene();

        for (let i = 0; i < events.length; ++i) {
            const event = events[i];

            for (let n = node; n; n = n.parent) {
                const comp = ComponentMap.get(n, EffectsComponent);
                if (comp) {
                    const effects = comp.findEffects(event);
                    if (effects && effects.length) {
                        return { event, effects };
                    }
                }
            }

            const effects = this.findInBundles(event);
            if (effects && effects.length) {
                return { event, effects };
            }
        }
    }

    applySound(effect) {
        if (this.isLogEnabled()) {
            console.log("effects apply sound", effect);
        }

        const url = bundles[effect.bundle] && bundles[effect.bundle].urls[effect.sound];
        if (!url || !url.isLoaded()) {
            return null;
        }

        const handler = { kind: "sound" };
        const options = {};
        if (effect.throttle !== undefined) {
            options.throttle = effect.throttle;
        }
        if (effect.loop) {
            options.loop = true;
        }
        const start = () => {
            handler.timeoutId = undefined;
            handler.sound = cleverapps.audio.playSound(url, Object.keys(options).length ? options : undefined);
        };

        if (effect.delay) {
            handler.timeoutId = cleverapps.timeouts.setTimeout(start, effect.delay * 1000);
        } else {
            start();
        }
        return handler;
    }

    applyMusic(effect) {
        if (this.isLogEnabled()) {
            console.log("effects apply music", effect);
        }

        const url = bundles[effect.bundle] && bundles[effect.bundle].urls[effect.music];
        if (!url || !url.isLoaded()) {
            return null;
        }

        const handler = { kind: "music", fadeOut: effect.fadeOut };
        const start = () => {
            handler.timeoutId = undefined;
            cleverapps.audio.insertDisk(url);
            if (effect.fadeIn) {
                cleverapps.audio.fadeIn(effect.fadeIn);
            }
            handler.music = true;
        };

        if (effect.delay) {
            handler.timeoutId = cleverapps.timeouts.setTimeout(start, effect.delay * 1000);
        } else {
            start();
        }
        return handler;
    }

    applyHaptic(effect) {
        if (this.isLogEnabled()) {
            console.log("effects apply haptic", effect);
        }

        const options = typeof effect.haptic === "number" ? { pattern: effect.haptic } : effect.haptic;
        const handler = { kind: "haptic" };
        const start = () => {
            handler.timeoutId = undefined;
            cleverapps.haptics.apply(options);
        };

        if (effect.delay) {
            handler.timeoutId = cleverapps.timeouts.setTimeout(start, effect.delay * 1000);
        } else {
            start();
        }
        return handler;
    }

    stop(composite) {
        if (!composite || !composite.handles) {
            return;
        }
        for (let i = 0; i < composite.handles.length; i++) {
            const h = composite.handles[i];
            if (!h) {
                continue;
            }
            if (h.timeoutId) {
                cleverapps.timeouts.clearTimeout(h.timeoutId);
            }
            if (h.sound) {
                cleverapps.audio.stopSound(h.sound);
            }
            if (h.music) {
                if (h.fadeOut) {
                    cleverapps.audio.fadeOutAndEject(h.fadeOut);
                } else {
                    cleverapps.audio.eject();
                }
            }
        }
    }

    isLogEnabled() {
        return cleverapps.flags && cleverapps.flags.logEffects
            || cleverapps.config.debugMode && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.e);
    }
}

cleverapps.effects = new Effects();
